const info = {
    siteTitle: `Soraride's Blog`,
    siteDescription: `そららいどの手作りブログ。技術系とか。製作物とか。`,
}

export default info
